import { Component, forwardRef, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Subject, of } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { IAirport } from '../../interfaces/IAirport';
import { AirportService } from '../../services/airport/airport.service';

@Component({
  selector: 'app-airport-search-input',
  templateUrl: './airport-search-input.component.html',
  styleUrls: ['./airport-search-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AirportSearchInputComponent),
      multi: true
    }
  ]
})
export class AirportSearchInputComponent
  implements OnInit, ControlValueAccessor {

  airportSearchText = '';
  airportSearchResults: IAirport[] = [];
  selectedAirport: IAirport | null = null;

  disabled = false;

  private airportSearchSubject = new Subject<string>();

  constructor(
    private _airportService: AirportService
  ) { }

  ngOnInit(): void {
    this.airportSearchSubject.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      switchMap((searchText: string) => {
        if (!searchText || searchText.trim().length < 2) {
          return of([]);
        }
        return this._airportService.searchAirports(searchText);
      })
    )
    .subscribe((results: IAirport[]) => {
      this.airportSearchResults = results;
    });
  }

  //--------------------------------------
  // ControlValueAccessor
  //--------------------------------------

  private onChange: any = () => {};
  private onTouched: any = () => {};

  writeValue(value: IAirport | null): void {
    this.selectedAirport = value;
    if (value) {
      this.airportSearchText =
        `${value.code} - ${value.name}`;
    } else {
      this.airportSearchText = '';
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  //--------------------------------------
  // Search
  //--------------------------------------

  onAirportSearchTextChange() {
    this.selectedAirport = null;
    this.onChange(null);
    this.airportSearchSubject.next(this.airportSearchText);
  }

  selectAirport(airport: IAirport) {
    this.selectedAirport = airport;
    this.airportSearchText =
      `${airport.code} - ${airport.name}`;
    this.airportSearchResults = [];
    this.onChange(airport);
    this.onTouched();
  }

  hideResults() {
    setTimeout(() => {
      this.airportSearchResults = [];
    }, 200);
  }

}